<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="d-flex align-items-center my-1 mx-2">
      <h2 class="me-4">Popup Modals</h2>
      <router-link to="/popup-modal/add">
        <button v-if="permissions.ADD_CONTENT === 'Y'" class="btn btn-sm border border-primary text-primary">
          Add New Modal
        </button>
      </router-link>
    </div>
    <div v-if="loading" class="text-center">
      <div class="text-center mb-3 justify-content-between">
        <b-spinner variant="primary"></b-spinner>
      </div>
    </div>
    <div v-else class="d-flex flex-column mx-2 mb-5">
      <!--      <h1 class="mb-5" style="display: flex;">Popup Modals</h1>-->

      <!-- page size  -->
      <div class="mt-3 rounded-3 bg-white p-3 shadow">
        <b-row class="mt-2">
          <b-col class="col-3 p-1" lg="6" md="4" sm="6">
            <b-form-group class="ms-2 col-lg-4 col-sm-4 col-12">
              <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"
                             class="col-md-4" size="sm"></b-form-select>
            </b-form-group>
          </b-col>
          <!-- search  -->
          <b-col>
            <div class="d-flex flex-row">
              <b-form-input v-model="filter" :formatter="searchFormatter" class="me-2"
                            placeholder="Type to filter data" type="search"></b-form-input>
              <button class="rounded btn-info me-4" @click="onSearch">Search</button>
            </div>
          </b-col>

        </b-row>
        <b-table :busy="loading" :current-page="currentPage" :fields="fields" :items="popupData" :per-page="perPage"
                 bordered hover
                 responsive striped>
          <template #cell(active_yn)="row">
            <div v-if="row.item.active_yn === 'Y'" class="badge bg-success">
              Active
            </div>
            <div v-else class="badge bg-danger">
              Inactive
            </div>
          </template>
          <template #cell(actions)="row">
            <div class="d-flex gap-1 justify-content-center">
              <!--            v-if="permissions.UPDATE_USERS == 'Y'"-->
              <router-link :to="{ name: 'PopupModalDetails', params: {popupID: row.item.id} }"
                           class="btn btn-info btn-sm"
                           type="button">
                <i class="fa-regular fa-pen-to-square"></i>
              </router-link>
              <!--            v-if="permissions.DELETE_USERS == 'Y'"-->
              <button
                  class="btn btn-danger btn-sm delete-button" @click="deletePopup(row.item.id)"><span
                  class="fa-solid fa-trash"></span></button>
            </div>
          </template>
          <template #table-busy>
            <div class="text-center text-danger my-2 px-2">
              <b-spinner class="align-middle mx-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
        <!-- Pagination -->
        <b-row>
          <b-col class="mt-2" md="12" sm="12">
            <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
                          align="center" class="my-0" next-text="Next" prev-text="Prev">
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import popupModalService from '@/services/popup-modal.service';
import Config from '@/config';
import {notify} from "@kyvg/vue3-notification";
// import {notify} from "@kyvg/vue3-notification";

export default {
  name: 'PopupModal',
  components: {},
  mounted() {
    this.imageBasePath = Config.apiFileBasePath;
    this.getPopupData();
  },
  created() {
    this.permissions = JSON.parse(localStorage.getItem("permissions"));
  },
  data() {
    return {
      permissions: {},
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Theme Options',
          to: '/portal-header'
        }, {
          text: 'Popup Modal Options',
          href: '#'
        }
      ],
      imageBasePath: null,
      loading: false,
      popupData: [],
      fields: [
        {
          label: 'Title', key: 'title', sortable: true, thStyle: {width: "22%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Status', key: 'active_yn', sortable: true,
          thStyle: {width: "20%"}, tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Publish Date', key: 'publish_date', sortable: true, thStyle: {width: "23%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          key: 'expiry_date', label: 'Expiry Date', sortable: false,
          class: 'text-center', thStyle: {width: "15%"},
          filterByFormatted: true
        },
        {key: 'actions', label: 'Actions', class: 'text-center', thStyle: {width: "20%"},},
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [1, 5, 10, 100],
      filter: '',
      backupPopupData: [],
    }
  },
  methods: {
    searchFormatter(data) {
      this.filter = data;
      if (this.filter != null && this.filter != "") {
        this.popupData = [];
        this.backupPopupData.forEach(item => {
          if (item.title.toLowerCase().includes(this.filter.toLowerCase())) {
            this.popupData.push(item);
          }
        });
      } else {
        this.popupData = this.backupPopupData;
      }
      this.totalRows = this.popupData.length;
      this.currentPage = 1;
      return data;
    },
    onSearch() {
      if (this.filter != null && this.filter != "") {
        this.allUsers = [];
        this.backupAllUsers.forEach(user => {
          if (user.user_name.toLowerCase().includes(this.filter.toLowerCase())) {
            this.allUsers.push(user);
          }
        });
      } else {
        this.allUsers = this.backupAllUsers;
      }
      this.totalRows = this.allUsers.length;
      this.currentPage = 1;
    },
    async deletePopup(id) {
      try {
        const result = await this.$swal({
          title: 'Are you sure, You want to Delete this modal?',
          showCancelButton: true,
          cancelButtonText: 'No',
          cancelButtonColor: '#dd3333',
          showConfirmButton: true,
          confirmButtonText: 'Yes',
          confirmButtonColor: '#007bff',
        });
        if (result.isConfirmed) {
          this.loading = true;
          const response = await popupModalService.deletePopup(id);
          this.loading = false;
          if (response.data) {
            if (response.data.messageCode === 1) {
              notify({
                type: "success",
                title: "Delete Menu",
                text: response.data.message,
              });
              await this.getPopupData();
            } else {
              notify({
                type: "error",
                title: "Error",
                text: response.data.message,
              });
            }
          }
        }
      } catch (error) {
        this.loading = false;
      }
    },
    async getPopupData() {
      try {
        this.loading = true;
        const response = await popupModalService.getAllPopupModalData();
        this.loading = false;
        if (response.data) {
          this.popupData = response.data;
          this.backupPopupData = this.popupData;
          this.totalRows = this.popupData.length;
        }
      } catch (error) {
        this.loading = false;
      }
    },

  }
}
</script>

<style scoped>

</style>
